import { defineMessages } from 'react-intl'

export default defineMessages({
    requiredError: {
        defaultMessage: 'Debes indicar la ciudad.',
    },
})
